import ReactDOM from "react-dom";
import React from "react";

import { UiUtils } from "../common/uiUtils";

const ConsentRevocation = (props) => {
    return <div>
               <button className="btn btn-primary" type="button" disabled={!UiUtils.areCookiesConsented()} onClick={() => {
            UiUtils.revokeCookieConsent();
            window.location.reload();
        }}>
                   Revoke cookie consent
               </button>
           </div>;
}

const startInfo = () => {
    ReactDOM.render(<ConsentRevocation/>,
        document.getElementById("consent-revocation"));
}

export { startInfo };